import { render, staticRenderFns } from "./PurchaseOrderLayout.vue?vue&type=template&id=07cabfd8&scoped=true"
import script from "./PurchaseOrderLayout.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cabfd8",
  null
  
)

export default component.exports